var domain = 'https://js.driftt.com';
/* eslint-disable */
var loadScript = function loadScript() {
  if (window.drift) return false;
  !function () {
    var t = window.driftt = window.drift = window.driftt || [];
    if (!t.init) {
      if (t.invoked) {
        return void (window.console && console.error && console.error('Drift snippet included twice.'));
      }
      //eslint-disable-next-line  @typescript-eslint/no-extra-semi
      ;
      t.invoked = !0, t.methods = ['identify', 'config', 'track', 'reset', 'debug', 'show', 'ping', 'page', 'hide', 'off', 'on'], t.factory = function (e) {
        return function () {
          var n = Array.prototype.slice.call(arguments);
          return n.unshift(e), t.push(n), t;
        };
      }, t.methods.forEach(function (e) {
        t[e] = t.factory(e);
      }), t.load = function (t) {
        var _i$parentNode;
        var e = 3e5,
          n = Math.ceil(new Date() / e) * e,
          o = document.createElement('script');
        o.type = 'text/javascript', o.async = !0, o.crossOrigin = 'anonymous', o.src = 'https://js.driftt.com/include/' + n + '/' + t + '.js';
        var i = document.getElementsByTagName('script')[0];
        (_i$parentNode = i.parentNode) === null || _i$parentNode === void 0 || _i$parentNode.insertBefore(o, i);
      };
    }
  }();
  return true;
};
/* eslint-enable */

var load = function load(_ref) {
  var providerKey = _ref.providerKey,
    setState = _ref.setState,
    _ref$beforeInit = _ref.beforeInit,
    beforeInit = _ref$beforeInit === void 0 ? function () {
      return undefined;
    } : _ref$beforeInit,
    _ref$onReady = _ref.onReady,
    onReady = _ref$onReady === void 0 ? function () {
      return undefined;
    } : _ref$onReady;
  var loaded = loadScript();

  // Continue as long as drift hasn’t already been initialised.
  if (loaded) {
    beforeInit();
    window.drift.load(providerKey);
    window.drift.SNIPPET_VERSION = '0.3.1';
    window.drift.on('ready', function () {
      setState('complete');
      onReady();
    });
  }
  return loaded;
};
var open = function open() {
  return window.drift.on('ready', function (api) {
    return api.showWelcomeMessage();
  });
};
export default {
  domain: domain,
  load: load,
  open: open
};